import routes from '../constants/routes';

import {
  BulkUploadPage,
  DashboardPage,
  DataExportPage,
  ErrorPage,
  InviteUserPage,
  LoadingPage,
  MaintenanceModePage,
  MessagePage,
  PermissionPage,
  TeamListPage,
  UserAnalyticsPage,
  UserDetailPage,
  UserListPage,
  WhiteLabelPage,
} from './lazyRoutesComponent';

const routesConfig = {
  redirectIfNotFound: true,
  secureDefaultRoute: routes.DASHBOARD,
  unsecureDefaultRoute: routes.DASHBOARD,
  routes: [
    {
      path: routes.DASHBOARD,
      component: DashboardPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.ERROR_PAGE,
      component: ErrorPage,
      exact: true,
      type: 'PUBLIC_ROUTE',
      name: 'Error Page',
    },
    {
      path: routes.INVITEUSER,
      component: InviteUserPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.USER_LIST,
      component: UserListPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.WHITE_LABEL,
      component: WhiteLabelPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.PERMISSION,
      component: PermissionPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.USERDETAIL,
      component: UserDetailPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.EDITUSER,
      component: InviteUserPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.MESSAGE,
      component: MessagePage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.TEAM_LIST,
      component: TeamListPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.BULK_UPLOAD,
      component: BulkUploadPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.USER_ANALYTICS,
      component: UserAnalyticsPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.DATA_EXPORT,
      component: DataExportPage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
    {
      path: routes.LOADING_PAGE,
      component: LoadingPage,
      exact: true,
      type: 'AUTH_ROUTE',
      name: 'Loading Page',
    },
    {
      path: routes.MAINTENANCE_MODE,
      component: MaintenanceModePage,
      exact: true,
      type: 'AUTH_ROUTE',
    },
  ],
};

export default routesConfig;
